import MuiBadge, { BadgeProps } from '@mui/material/Badge';
import { styled } from 'styled-components';

export const Badge = styled(MuiBadge)<BadgeProps>`
    > span:last-child {
        border: 2px solid ${({ theme }) => theme.vars.palette.common.white};
        font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    }
`;
